<template>
  <div class="wrap personal-wrap flex-column">
    <div class="flex-item">
      <div class="quitsuccess">
        您的申请已经提交，系统正在处理，稍后您可以在订单详情页查看结果。感谢您对美心的支持！
      </div>
      <div class="editButton">
        <mu-raised-button label="确定" fullWidth primary @click="save" />
      </div>
    </div>
    <!-- <menus></menus> -->
  </div>
</template>
<script type="text/javascript">
import menus from '@components/menus/menus';
export default {
  data() {
    return {}
  },
  methods: {
    save() {
      this.$router.push({
        path: '/main/myorders'
      })
    },
  },
  components: {
    menus
  }
}

</script>
<style lang="scss" rel="stylesheet/scss">
@import 'personal.scss';
.quitsuccess {
  padding: 0.35rem;
  background: #fff;
  margin: 0.35rem;
  @include font-dpr(14px);
}

</style>



// WEBPACK FOOTER //
// quitsuccess.vue?8be55ec4